import { FirebaseMessagingService } from '../../services/firebase-messaging/firebase-messaging.service'
import { ImageService } from './../../services/image/image.service'
import { InvitationService } from '../../services/invitation/invitation.service'
import { UserService } from 'src/app/services/user/user.service'
import { IUser } from '../../services/user/user.service'
import { AlertService } from '../../services/alert/alert.service'
import { Component, OnDestroy, OnInit, ViewChild, NgZone } from '@angular/core'
import { IonTabs, Platform } from '@ionic/angular'
import { LoadingController } from '@ionic/angular'
import { DEFAULT_BACKGROUND_COLOR } from 'src/app/config'
import { ExtraService } from '../../services/extra/extra.service'

import { File } from '@ionic-native/file/ngx'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit, OnDestroy {

  @ViewChild('dashboardTabs', { static: true }) dashboardTabs: IonTabs

  user: IUser = null
  userSubscription: any

  invitationCount = 0
  invitationListSubscription: any

  routerSubscription: any

  isEventsTabSelected = true

  backgroundImageStyle: string
  backgroundImagePathSubscription: any

  pushNotificationsSubscription: any

  platformResumeSubscription: any

  constructor(
    private userService: UserService,
    private invitationService: InvitationService,
    private alert: AlertService,
    private imgService: ImageService,
    private loadingController: LoadingController,
    private fmService: FirebaseMessagingService,
    private platform: Platform,
    private zone: NgZone,
    private extraService: ExtraService,
    private file: File
  ) { }

  ngOnInit() {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
    this.invitationListSubscription = this.invitationService.invitationsList.subscribe(value => this.invitationCount = value.length)
    this.imgService.initialize()
    this.backgroundImagePathSubscription = this.imgService.appBackground.subscribe(value => {
      const url = this.imgService.urlPathForImage(value)
      if (url && url !== '')
        this.backgroundImageStyle = `url(${url}) no-repeat center/cover fixed`
      else
        this.backgroundImageStyle = DEFAULT_BACKGROUND_COLOR
    })

    this.platform.ready().then(() => {
      // isAndroid - (TEMPORARY SOLUTION)
      if (this.file.externalDataDirectory) {
        console.log('On Device: initializing fcm device token')
        this.fmService.getDeviceToken()
          .then(deviceToken => this.userService.setDeviceToken(this.user.token, deviceToken))
          .then(() =>
            this.fmService.initialize().then(() => {
              this.pushNotificationsSubscription = this.fmService.pushNotifications.subscribe(value => {
                if (value) {
                  this.alert.toast(value, 5, 'top')
                  this.zone.run(() => this.update(false))
                }
              })
            })
          )
          .catch((err) => this.alert.errorHandler(err, false))
      }
    })

    this.platformResumeSubscription = this.platform.resume.subscribe(() => {
      this.zone.run(() => this.update(false))
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.invitationListSubscription.unsubscribe()
    this.backgroundImagePathSubscription.unsubscribe()
    if (this.pushNotificationsSubscription)
      this.pushNotificationsSubscription.unsubscribe()
    this.fmService.destroy()
    this.platformResumeSubscription.unsubscribe()
  }

  ionViewWillEnter() {
    this.update()
  }

  async update(showLoading = true) {
    let loading = null

    if (showLoading) {
      loading = await this.loadingController.create({
        message: 'Wird geladen',
        showBackdrop: false
      })

      await loading.present()
    }

    try {
      await this.extraService.updateAllLists(this.user.token, this.user.id)
    } catch (err) {
      this.alert.errorHandler(err, 'Fehler beim Aktualizieren von Daten!')
    } finally {
      if (loading)
        loading.dismiss()
    }
  }

  onTabChanged() {
    this.isEventsTabSelected = this.dashboardTabs.getSelected() === 'event'
  }
}
